import { isApiError } from "../http";

export const PASSWORD_LENGTH = { min: 6, max: 20 } as const;

export const USER_FIELD_MAX = { username: 20, name: 10, code: 20, phoneNumber: 20 } as const;

export const PASSWORD_HINT = `${PASSWORD_LENGTH.min}~${PASSWORD_LENGTH.max}자`;

export function passwordLengthError(password: string): string | null {
  return password.length < PASSWORD_LENGTH.min || password.length > PASSWORD_LENGTH.max
    ? `${PASSWORD_HINT}로 입력하세요.`
    : null;
}

export const isWrongCurrentPassword = (err: unknown) =>
  isApiError(err) && err.response?.error === "INVALID_ID_OR_PASSWORD";
